module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_shibuya-b6dd77a97953cda034774686166dd2c1.jpg";